<form [formGroup]="attributesForm">
  <h5 class="text-primary">Attributes</h5>
  <button type="button"
          class="btn btn-outline-primary border-0 float-end"
          (click)="toggleEditMode()">
    @if (!editMode) {
      <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
    } @else {
      <fa-icon [icon]="['far', 'save']"></fa-icon>
    }
  </button>

  <table class="table table-sm table-bordered">
    <thead>
      <tr>
        <th scope="col">Code</th>
        <th scope="col">Value</th>
        <th scope="col">Type</th>
        @if (editMode) {
          <th scope="col"></th>
        }
      </tr>
    </thead>

    <tbody formArrayName="attributes">
      @for (control of attributes.controls; track control; let i = $index) {
        <ng-container [formGroupName]="i">
          <tr [@pulse]="control">
            <td>
              @if (!editMode) {
                <span class="col-form-label">{{ control.get('code')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="code-{{ i }}"
                       type="text"
                       formControlName="code" />
              }
            </td>
            <td>
              @if (!editMode) {
                <span class="col-form-label">{{ control.get('value')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="value-{{ i }}"
                       type="text"
                       formControlName="value" />
              }
            </td>
            <td>
              @if (!editMode) {
                <span class="col-form-label">{{ control.get('type')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="type-{{ i }}"
                       type="text"
                       formControlName="type" />
              }
            </td>
            @if (editMode) {
              <td>
                <button type="button"
                        class="btn btn-outline-danger border-0"
                        (click)="deleteAttribute(i)">
                  <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                </button>
              </td>
            }
          </tr>
        </ng-container>
      }
    </tbody>
  </table>

  @if (editMode) {
    <button type="button"
            class="btn btn-primary float-end"
            (click)="addAttribute()">+ Add attribute</button>
  }
</form>